import { useContext, useState, useEffect } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { Route, Routes } from 'react-router';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import jwt_decode from 'jwt-decode';
import FirstTimeChecker from './composed/firsttimechecker/FirstTimeChecker';
import { StoreHeaderDataContext } from './context-api/StoreHeaderDataProvider';
import { LoginDataContext } from './context-api/LoginDataProvider';
import { GlobalStateDataContext } from './context-api/GlobalStateDataProvider';
import { isDesktop, isIpad, isMobile } from './global/ScreenSizeHelper';
import Home from './pages/home/Home';

import NoMatch from './composed/noMatch/NoMatch';
import StoreHeaderMobile from './composed/storeheader/StoreHeaderMobile';
import StoreHeaderDesktop from './composed/storeheader/StoreHeaderDesktop';
import StoreFooterMobile from './composed/storefooter/StoreMobileFooter';
import StoreMenu from './pages/storemenu/StoreMenu';
import StoreList from './pages/storelist/StoreList';
import {
  getUrlParams,
  getUrlPath,
  getUrlFullPath,
  removeParamFromUrl,
  redirectedFromUrlInfo,
} from './global/getUrl';
import AlertDialog from './atomic/Dialog/Dialog';
import { localStorageKeys } from './global/constants';
import { zipCodeValidator } from './global/validation';
import Login from './pages/loginflow/Login';
import Pdp from './pages/pdp/Pdp';
import ForgotPassword from './pages/loginflow/ForgotPassword';
import ResetPassword from './pages/loginflow/ResetPassword';
import CustomerAccount from './pages/customeraccount/CustomerAccount';
import VerifyEmailDirectPage from './pages/directpages/VerifyEmailPage';
import { getTimeDifference } from './global/getTimeDifference';
import { OnTheMenuDataContext } from './context-api/OnTheMenuDataProvider';
import moment from 'moment';
import UpgradeSubscription from './pages/upgradesubscription/UpgradeSubscription';
import Checkout from './pages/checkout/Checkout';
import OrderConfirmation from './pages/orderconfirmation/OrderConfirmation';
import OrderTrackingLive from './composed/orderConfirmation/OrderTrackingLive';
import Pricing from './pages/pricing/Pricing';
import Signup from './pages/signup/Signup';
import { SignUpInfoDataContext } from './context-api/SignUpInfoDataProvider';
import EmailVerifyOtp from './pages/signup/EmailVerifyOtp';
import PaymentAndAddress from './pages/paymentAndAddress/PaymentAndAddress';
import OnLoadDiscountBanner from './composed/onLoadDiscountBanner/OnLoadDiscountBanner';
import UpSaleProduct from './pages/upsale/UpSaleProduct';
import NextDayPromotionMeal from './pages/nextdaypromotionmeal/NextDayPromotionMeal';
import LegalCenter from './pages/agreements/LegalTerms';
import StoreFooter from './composed/storefooter/StoreFooter';
import CustomerSupport from './pages/support/CustomerSupport';
import UnderConstruction from './pages/underconstruction/Under_Construction';
import AboutUs from './pages/support/AboutUs';
import { googletrackStorePageView } from './global/googleAnalytic';
import IosAndAndroidAppOnly from './pages/comingsoon/IosAndAndroidAppOnly';
import HiringNowList from './pages/Jobs/HiringNow';
import ComingSoonHeader from './pages/comingsoon/Header';
import ServiceCheckAddress from './pages/serviceCheckAndWaitList/ServiceCheckAddress';
import ReportUiBugForm from './pages/reportUiBug/ReportBugForm';
import BetaBanner from './pages/reportUiBug/BetaBugBanner';
// import StoreListDesktop from "./pages/kitchenList/StoreListDesktop";

function App() {
  const {
    OnLoadInformation,
    openLiveOrderTracking,
    setOpenLiveOrderTracking,
    setUrlPromoCode,
    setUrlInflueCode,
    setRedirectedUrlInfo,
    orderStatusResponse,
    expoMobileData,
    setExpoMobileData,
  } = useContext(GlobalStateDataContext);
  const {
    ZIP_CODE,
    CUST_SET_ZIPCODE,
    CUSTINFO_API_FETCHED_TIME,
    KITCHEN_API_FETCHED_TIME,
    URL_REDIRECTED_FROM,
    TOKEN,
    DEBUG_LOGOUT_POINT,
    URL_PROMO_CODE,
    URL_INFLUE_CODE,
    VISITED_COUNT,
    FINGER_PRINT_USER,
  } = localStorageKeys;

  const {
    isDeliverable,
    onGetKitchenByZipcode,
    onGetKitchenByZipcodeHandler,
    kitchensByZipcode,
    HeaderVisibility,
    zipcode,
  } = useContext(StoreHeaderDataContext) || {};
  const { error, loading, success } = kitchensByZipcode;
  const {
    isLoggedIn,
    onCustomerInformationApiHandler,
    customerInfoData,
    onLogout,
    setFingerPrint,
  } = useContext(LoginDataContext);
  const { selectedDate, ShowPromotionalKitchen } = useContext(OnTheMenuDataContext);
  const singnUpContext = useContext(SignUpInfoDataContext);
  const { signUpPageEmail } = singnUpContext;

  const urlParamsObject = getUrlParams();
  const urlZipcode = urlParamsObject.zipcode;
  const urlPromoCodeOne = urlParamsObject.promo;
  const urlInfluncer = urlParamsObject.promoterid;
  const urlStoreName = urlParamsObject?.storename;
  const urlPagetype = urlParamsObject?.pagetype === 'waitlist';

  const getPromoLocalStorage = () => localStorage.getItem(URL_PROMO_CODE);
  const checkPromoCode = urlPromoCodeOne || getPromoLocalStorage();

  const { joinedOrdersTotal, payAsYouGoOrdersTotal, mealOrdersTotal, PromotionalOrdersTotal } =
    orderStatusResponse?.data?.data || {};

  const hasAnyOrder =
    joinedOrdersTotal || payAsYouGoOrdersTotal || mealOrdersTotal || PromotionalOrdersTotal;

  const localStorageZipcode = () =>
    localStorage.getItem(CUST_SET_ZIPCODE) || localStorage.getItem(ZIP_CODE);
  const [open, setOpen] = useState(false);
  const [displayText, setdisplayText] = useState('');
  const [showAgreeButton, setshowAgreeButton] = useState(true);
  const [onLoadBannerOpen, setOnLoadBannerOpen] = useState(false);

  const [showDisagreeButton, setshowDisagreeButton] = useState(true);
  const checkUrlPath = getUrlPath().includes('/onthemenu');
  const UrlPathForPromoDisplay = ['/onthemenu'].some((path) => getUrlPath().includes(path));

  const navigate = useNavigate();
  const getCustApiLastFetchTime = () => localStorage.getItem(CUSTINFO_API_FETCHED_TIME);
  const getKitchenApiLastFetchTime = () => localStorage.getItem(KITCHEN_API_FETCHED_TIME);
  const TokenLocalStorage = () => localStorage.getItem(TOKEN);
  const CheckAcctStatusReason = customerInfoData?.data?.data?.user_Info?.reason_status;
  const CheckResponceStatus = customerInfoData?.data?.data?.success;

  const setLocalStorageDebug = async (param1, param2) => localStorage.setItem(param1, param2);
  const triggerLogout = async () => {
    await onLogout();
    navigate('/onthemenu');
    window.location.reload();
  };

  const onAgree = async () => {
    const zipcodeCheck = await onGetKitchenByZipcode(urlZipcode);
    if (urlZipcode === zipcodeCheck?.geolocation?.zipcode) {
      setOpen(false);
    } else {
      setdisplayText(`Oops! We don’t currently serve that ZIP code ${urlZipcode}`);
      // setshowDisagreeButton(false)
      setshowAgreeButton(false);
      setTimeout(() => {
        setOpen(false);
      }, 5000);
      removeParamFromUrl('zipcode');
      // Add Timmer in dialog to show it will close
    }
  };

  const onDisagree = () => {
    removeParamFromUrl('zipcode');
    setOpen(false);
  };

  const init = async () => {
    try {
      if (urlZipcode && checkUrlPath) {
        if (!localStorageZipcode()) {
          await onGetKitchenByZipcode(urlZipcode);
        } else if (urlZipcode !== localStorageZipcode()) {
          setdisplayText(`Do you want to switch to zipcode ${urlZipcode}`);
          setOpen(true);
        }
      }
    } catch (error) {
      console.log('--------init App.js error', error);
    }
  };

  const reFetchApis = async () => {
    try {
      if (isLoggedIn) {
        if (!TokenLocalStorage()) {
          // Trigger logout as token is missing in local storage
          await triggerLogout();
          await setLocalStorageDebug(DEBUG_LOGOUT_POINT, 'App reFetchApis() NO1');
          return;
        }
        const decodedToken = jwt_decode(TokenLocalStorage());
        const { exp } = decodedToken;
        const tokenTime = await getTimeDifference(exp);

        // console.log('---Tokens', tokenTime)
        if (tokenTime && tokenTime.inMinutes >= 1) {
          // Trigger logout method as token is expired
          await triggerLogout();
          await setLocalStorageDebug(DEBUG_LOGOUT_POINT, 'App reFetchApis() NO2');
          return;
        }

        // if customer info API Retuns false and 'User does not exist' we have to logo out
        if (
          customerInfoData?.success === false &&
          customerInfoData?.errorMessage === 'User does not exist'
        ) {
          await triggerLogout();
          await setLocalStorageDebug(DEBUG_LOGOUT_POINT, 'App reFetchApis() NO3');
          return;
        }
      }

      const custApi = await getTimeDifference(getCustApiLastFetchTime());
      const kitchApi = await getTimeDifference(getKitchenApiLastFetchTime());
      // Refeching customer info API after 10 hours if user is logged in
      if (custApi && custApi.inHours >= 10 && isLoggedIn) {
        await onCustomerInformationApiHandler();
        console.log('----refecthing customer api');

        // Account status Inactive by admin
        if (CheckResponceStatus === true && CheckAcctStatusReason === 'Inactive by admin') {
          //trigger logout method
          await triggerLogout();
          await setLocalStorageDebug(DEBUG_LOGOUT_POINT, 'App reFetchApis() NO4');
        }
      }
      // Refeching servingZipcode  API after 10 hours to make sure we have updated kitchen names
      if (localStorageZipcode() !== null && kitchApi && kitchApi.inHours >= 10) {
        const setLocalStorage = true;
        await onGetKitchenByZipcodeHandler(localStorageZipcode(), setLocalStorage);
        console.log('----refetching kitchen api');
      }
    } catch (error) {
      console.log('--------Error in reFetchApis method', error);
    }
  };

  const OnloadDiscountBanner = () => {
    if (checkPromoCode && isDeliverable) {
      const currentVisitCount = parseInt(localStorage.getItem(VISITED_COUNT) || 0);
      //  const openOnCounts = [1, 3, 8, 18, 30]; // when visited count is in this array it will show that onLoadDiscountBanner

      const openOnCounts = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
      if (currentVisitCount + 1 >= 31) {
        //remove  keys from ,local storage when user visit reach 31

        localStorage.removeItem(VISITED_COUNT);
        setUrlPromoCode(undefined);
        setUrlInflueCode(undefined);
        setRedirectedUrlInfo('');
        localStorage.removeItem(URL_PROMO_CODE);
        localStorage.removeItem(URL_INFLUE_CODE);
        localStorage.removeItem(URL_REDIRECTED_FROM);
      } else {
        if (openOnCounts.includes(currentVisitCount + 1)) {
          setOnLoadBannerOpen(true);
        }

        // set Condition on URL
        localStorage.setItem(VISITED_COUNT, currentVisitCount + 1);
      }
    }
  };

  // Creating unique decive fingerprint for a user
  useEffect(() => {
    const generateFingerprint = async () => {
      const gettingFingerPrint = () => localStorage.getItem(FINGER_PRINT_USER);
      try {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        const id = result.visitorId;
        if (id) {
          setFingerPrint(id);
          googletrackStorePageView({
            pageName: 'StoreList',
            storeName: urlStoreName,
            zipcode: localStorageZipcode(),
            promo: gettingFingerPrint() === null ? urlPromoCodeOne : 'none',
            influe: gettingFingerPrint() === null ? urlInfluncer : 'none',
            fingerPrint: id,
          });
          localStorage.setItem(FINGER_PRINT_USER, id);
        }
      } catch (error) {
        console.error('Fingerprint error:', error);
      }
    };

    if (isDeliverable) {
      generateFingerprint();
    }

    // User should not be logged in as we will add influncer_promoter_id when they sigup for first time
    if (urlInfluncer !== undefined && isLoggedIn === false) {
      localStorage.setItem(URL_INFLUE_CODE, urlInfluncer);
      setUrlInflueCode(urlInfluncer);
    }
  }, [isDeliverable, urlInfluncer]);

  useEffect(() => {
    const handleVisiblityChange = (event) => {
      if (document.visibilityState === 'visible') {
        // console.log("tab is active")
        OnloadDiscountBanner();

        if (
          selectedDate &&
          selectedDate instanceof moment &&
          selectedDate.startOf('day') < moment().startOf('day')
        ) {
          window.location.reload();
          console.log('-----Due to date change hard reloaded');
        }

        reFetchApis();
      } else {
        // console.log("tab is inactive do nothing");
      }
    };
    document.addEventListener('visibilitychange', handleVisiblityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisiblityChange);
    };
  }, [selectedDate, isDeliverable]);

  useEffect(() => {
    OnloadDiscountBanner(); // This is for OnloadDiscountBanner
  }, [isDeliverable]);

  useEffect(() => {
    OnLoadInformation();

    if (urlParamsObject.zipcode && checkUrlPath) {
      const isZipValid = zipCodeValidator(urlZipcode);
      if (isZipValid) {
        init();
      } else {
        setdisplayText(`Invalid Zipcde ${urlZipcode}`);
        setOpen(true);
        setshowDisagreeButton(false);
        setshowAgreeButton(false);
        setTimeout(() => {
          removeParamFromUrl('zipcode');
          setOpen(false);
        }, 5000);
      }
    }
  }, []);

  // React Native is sending Data in this block
  useEffect(() => {
    const handleRNCustomEvent = (ev) => {
      // ev.detail is the payload sent from RN
      // console.log("Received Custom even from react native:", ev.detail);
      setExpoMobileData(JSON.stringify(ev.detail, null, 2));
    };

    window.addEventListener('rn:message', handleRNCustomEvent);

    return () => {
      window.removeEventListener('rn:message', handleRNCustomEvent);
    };
  }, []);

  // We have to remove This when we go Live

  if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'development') {
    return (
      <>
        <ComingSoonHeader />
        <BetaBanner />
        <Routes>
          <Route path='/' element={<ServiceCheckAddress />}></Route>
          <Route path='*' element={<ServiceCheckAddress />}></Route>
          {/* <Route
            path='*'
            element={
              urlStoreName === undefined ? <ServiceCheckAddress /> : <IosAndAndroidAppOnly />
            }
          /> */}
          <Route path='/career' element={<HiringNowList />} />
          <Route path='/report-bug' element={<ReportUiBugForm />}></Route>
        </Routes>
      </>
    );
  }

  // We have to remove This when we go Live
  // if (process.env.NODE_ENV === 'production') {
  //   return (
  //     <>
  //       <ComingSoonHeader />
  //       <Routes>
  //         <Route path='/' element={<IosAndAndroidAppOnly />}></Route>
  //         <Route path='/career' element={<HiringNowList />} />
  //         <Route path='*' element={<IosAndAndroidAppOnly />}></Route>
  //       </Routes>
  //     </>
  //   );
  // }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{ flex: 1 }}>
        {!isMobile && <StoreHeaderDesktop />}
        {isMobile && HeaderVisibility && <StoreHeaderMobile />}
        {openLiveOrderTracking === false &&
          UrlPathForPromoDisplay &&
          !hasAnyOrder &&
          isDeliverable &&
          checkPromoCode && (
            <OnLoadDiscountBanner
              setOnLoadBannerOpen={setOnLoadBannerOpen}
              onLoadBannerOpen={onLoadBannerOpen}
            />
          )}

        <Routes>
          <Route
            path='/'
            element={
              !isDeliverable ? <Home /> : isDeliverable ? <StoreMenu /> : <FirstTimeChecker />
            }
          ></Route>
          <Route path='/onthemenu' element={isDeliverable ? <StoreList /> : <FirstTimeChecker />} />
          <Route
            path='/onthemenu/storemenu'
            element={isDeliverable ? <StoreMenu /> : <FirstTimeChecker />}
          />
          <Route path='/signup' element={isDeliverable ? <Signup /> : <FirstTimeChecker />}></Route>

          {/* We no logner using subcription signup flow ,now only payasyougo sigup flow*/}

          {/* <Route
            path='/pricing'
            element={isDeliverable ? <Pricing /> : <FirstTimeChecker />}
          ></Route> */}

          <Route
            path='/verifyemail'
            element={
              signUpPageEmail ? <EmailVerifyOtp /> : <NoMatch textmessage='Page not found' />
            }
          >
            {' '}
          </Route>
          <Route
            path='/emailverifydirect'
            element={isLoggedIn ? <VerifyEmailDirectPage /> : <Login />}
          ></Route>
          <Route path='/termsofservice' element={<LegalCenter />}></Route>
          <Route path='/privacypolicy' element={<LegalCenter />}></Route>
          <Route path='/support' element={<CustomerSupport />}></Route>

          <Route path='/aboutus' element={<AboutUs />}></Route>
          <Route path='/business' element={<UnderConstruction />}></Route>
          <Route path='/driver' element={<UnderConstruction />}></Route>
          <Route path='/career' element={<HiringNowList />}></Route>

          <Route
            path='/payment&address'
            element={isLoggedIn ? <PaymentAndAddress /> : <Login />}
          ></Route>

          <Route path='/login' element={!isLoggedIn && <Login />}></Route>
          <Route path='/forgotpassword' element={<ForgotPassword />}></Route>
          <Route path='/resetpassword' element={<ResetPassword />}></Route>
          <Route
            path='/onthemenu/storemenu/pdp'
            element={isDeliverable ? <Pdp /> : <FirstTimeChecker />}
          ></Route>
          <Route
            path='/customeraccount'
            element={isLoggedIn ? <CustomerAccount /> : <Login />}
          ></Route>
          <Route
            path='/customeraccount/deliveryaddress'
            element={isLoggedIn ? <CustomerAccount /> : <Login />}
          ></Route>
          <Route
            path='/customeraccount/cards'
            element={isLoggedIn ? <CustomerAccount /> : <Login />}
          ></Route>
          <Route
            path='/customeraccount/orders'
            element={isLoggedIn ? <CustomerAccount /> : <Login />}
          ></Route>
          <Route
            path='/customeraccount/subscription'
            element={isLoggedIn ? <CustomerAccount /> : <Navigate to='/login' replace />}
          ></Route>
          <Route path='/upgradesubscription' element={<UpgradeSubscription />}></Route>
          <Route path='/upsaleproducts' element={<UpSaleProduct />}></Route>
          <Route
            path='/nextdaypromotionmeal'
            element={
              ShowPromotionalKitchen() ? (
                <NextDayPromotionMeal />
              ) : (
                <Navigate to='/checkoutorder' replace />
              )
            }
          ></Route>

          <Route
            path='/checkoutorder'
            element={isLoggedIn ? <Checkout /> : <Navigate to='/login' replace />}
          ></Route>
          <Route path='/orderconfirmation' element={<OrderConfirmation />}></Route>
          <Route path='*' element={<NoMatch textmessage='Page not found' />}></Route>
        </Routes>
      </div>

      {isMobile && checkUrlPath && !openLiveOrderTracking && hasAnyOrder && (
        <div
          style={{
            display: 'flex',
            position: 'fixed',
            justifyContent: 'center',
            alignItems: 'center',
            width: '120px',
            height: '20px',
            backgroundColor: '#FF7A28',
            borderRadius: '5px 5px 0px 0px',
            color: 'white',
            fontSize: '12px',
            bottom: 63,
            left: 'calc(38% - 15px)',
            zIndex: 100005,
          }}
          onClick={() => {
            setOpenLiveOrderTracking(!openLiveOrderTracking);
          }}
        >
          Order status
        </div>
      )}

      {openLiveOrderTracking && checkUrlPath && isMobile && <OrderTrackingLive />}

      {isMobile && <StoreFooterMobile />}
      {(isDesktop || isIpad) && <StoreFooter />}

      <AlertDialog
        isLoading={loading}
        open={open}
        setOpen={setOpen}
        onAgree={onAgree}
        onDisagree={onDisagree}
        displayText={displayText}
        showAgreeButton={showAgreeButton}
        showDisagreeButton={showDisagreeButton}
      />
    </div>
  );
}

export default App;
